import { render, staticRenderFns } from "./Orderreturn.vue?vue&type=template&id=c3b3e360&scoped=true"
import script from "./Orderreturn.vue?vue&type=script&lang=js"
export * from "./Orderreturn.vue?vue&type=script&lang=js"
import style0 from "./Orderreturn.vue?vue&type=style&index=0&id=c3b3e360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b3e360",
  null
  
)

export default component.exports